'use strict';

/**
 * tab
 */
export const tab = (() => {
    const $tab = $('.js-tab');
    const $pannel = $('.js-tab-panel');

    const tab = () => {

        $(document).on('click', '.js-tab', function (e) {
            const $this = $(e.currentTarget);

            $tab.removeClass('is-active');
            $pannel.removeClass('is-active');
            $this.addClass('is-active');

            if ($this.hasClass('js-tab-01')) {
                $('.js-tab-panel-01').addClass('is-active');
            }
            else if ($this.hasClass('js-tab-02')) {
                $('.js-tab-panel-02').addClass('is-active');
            }
        });
    };

    const init = () => {
        tab();
    };

    return {
        init: init
    };
})();